import React, { FC, useState } from 'react'
import { PlusIcon } from '@heroicons/react/outline'
import { ConnectionsModal } from '../../Modals'
import { StyledSocialProfiles } from '..'

const SocialProfiles: FC = () => {
  const [showConnectionsModal, setShowConnectionsModal] = useState(false)

  return (
    <>
      <StyledSocialProfiles>
        <ConnectionsModal />
        <button className="new-profile-btn" onClick={() => setShowConnectionsModal(true)}>
          <PlusIcon />
          <span>Connect Social Account</span>
        </button>
      </StyledSocialProfiles>
      <ConnectionsModal
        isOpen={showConnectionsModal}
        onClose={() => setShowConnectionsModal(false)}
      />
    </>
  )
}

export default SocialProfiles
